<template>
  <div>
    <!-- 智能诊断 -->
    <detailBase
      :id="id"
      :user="user"
      :result="result"
      :checkbox="checkbox"
      :disease-info="diseaseInfo"
      :user-info="userInfo"
      @changeRecommandProduct="_setRecommandProduct"
    />
    <!-- 解决方案 -->
    <solution
      :hand-list="handList"
      :hand-list-simple="handListSimple"
      :say-list="sayList"
      :suit-list="suitList"
      :cannot-list="cannotList"
      :food-list="foodList"
      :food-book="foodBook"
      :progress="progress"
      @solution="_setSolution"
      @changeRecommandProduct="_setRecommandProduct"
    ></solution>
    <!-- 门店推荐 -->
    <recomendDoctor
      :id="id"
      :recommend-product-id="recommendProductId"
      :doctors="doctors"
      :product="product"
      :kele-product="keleProduct"
      :record_id="record_id"
      @changeRecommandProduct="_setRecommandProduct"
      @next="$emit('next', {}, 3)"
    ></recomendDoctor>
  </div>
</template>
<script>
import detailBase from './detailBase';
import solution from './solution';
import recomendDoctor from './recomendDoctor';

export default {
  components: {
    detailBase,
    solution,
    recomendDoctor
  },
  props: {
    record_id: [String, Number],
    id: [String, Number],
    status: [String, Number]
  },
  data() {
    return {
      userInfo: {},
      diseaseInfo: {},
      checkbox: {
        physique: true,
        solution: {
          solutionProduct: true,
          standardSolution: true,
          fastSolution: false,
          foodSolution: false,
          adjustSolution: false
        },
        recommand: {
          recommandProduct: false,
          productList: false
        }
      },
      user: {},
      result: {},
      product: [],
      doctors: [],
      recommendProductId: [],
      keleProduct: [],
      progress: {
        book: [],
        medicine: [],
        nutrition: [],
        physical: [],
        stick: [],
        fit_tuina: '',
        bubble: []
      },
      handList: {list: []},
      handListSimple: {list: []},
      sayList: {},
      foodList: {},
      foodBook: [],
      commodity: [],
      suitList: [],
      cannotList: []
    };
  },
  watch: {
    record_id: {
      handler(v) {
        if (v) {
          console.log(this.status);
          if (this.status === 'characteristic') {
            this.getCustomResult();
          } else {
            this.getRecord();
            this.getDoctors();
          }
        }
      },
      immediate: true
    }
  },
  methods: {
    _setRecommandProduct(event) {
      const {val, prop} = event;
      const SOLUTION_TYPE = 'solution';
      const PHYSIQUE_TYPE = 'physique';
      const SOLUTION_PRODUCT = 'solutionProduct';

      if (prop) {
        if (prop === SOLUTION_TYPE) {
          this.checkbox.solution[prop] = val;
        } else if (prop === PHYSIQUE_TYPE) {
          this.checkbox[prop] = val;
        } else if (prop === SOLUTION_PRODUCT) {
          this.checkbox.solution[prop] = val;
        } else {
          this.checkbox.recommand[prop] = val;
        }
      }
    },

    _setSolution(event) {
      const {val, prop} = event;
      this.checkbox.solution[prop] = val;
    },

    // 获取特色项目结果
    getCustomResult() {
      this.$http
        .post(this.$url.getCustomResult, {
          record_id: this.record_id
        })
        .then(res => {
          res.user.u_id = this.id;
          this.result = {
            type: 1,
            disease_name: res.massage.commodity_name
          };
          this.user = res.user;
          this.sayList = res.daily.split('\n').map((item, index) => {
            return {
              id: index,
              doctor_say: item
            };
          });
          this.doctors = res.masseur;
          res.product.other_commodity.forEach(it => {
            it.number = 1;
            it.now_price = it.price;
            it.all_price = it.price;
          });
          this.product = res.product.other_commodity;
          let sum = 0;
          const handData = [];
          res.hand.forEach(item => {
            sum += Number(item.minutes);
            handData.push({
              id: item.id,
              minutes: item.minutes,
              hand: `${item.name + item.minutes}分钟`
            });
          });
          this.handList = {
            list: handData,
            time: sum
          };
        })
        .catch(this.$catch);
    },
    getRecord() {
      this.$http
        .post(this.$url.getRecord, {
          u_id: this.id,
          record_id: this.record_id
        })
        .then(res => {
          this.keleProduct = {
            keleMore: res.product.more,
            keleCommodity: res.product.commodity
          };
          res.user.u_id = this.id;
          this.user = res.user;
          this.result = res.result;
          this.progress = res.progress;
          this.handList = res.handList;
          this.handListSimple = res.handListSimple;
          this.sayList = res.sayList;
          this.suitList = res.suit;
          this.cannotList = res.cannot;
          this.foodList = res.foodList;
          this.foodBook = res.foodBook;
          this.diseaseInfo = res.result;
          this.userInfo = res;
          this.recommendProductId = res.product.commodity.map(it => it.id);
          res.product.more = res.product.commodity.concat(res.product.more);
          res.product.more.forEach(it => {
            it.number = 1;
            it.now_price = it.price;
            it.all_price = it.price;
          });
          this.product = res.product.more;
        })
        .catch(this.$catch);
    },
    getDoctors() {
      this.$http
        .post(this.$url.getDoctors)
        .then(res => {
          this.doctors = res;
        })
        .catch(this.$catch);
    }
  }
};
</script>
